import React, { createElement } from 'react';
import { Space } from 'antd';
import ForwardBackwardsButton from '../../../../pages/Home/ForwardBackwardsButton';
import NavigationButton from './NavigationButton';
import { FaLaptopCode } from 'react-icons/fa'; // keep fa (not fa6)
import { useTranslation } from 'react-i18next';

const HistoryNavigation: React.FC = () => {
  const { t } = useTranslation(['navbar']);

  // ✅ Cast to a generic React component type to satisfy strict TS
  const IconComp = FaLaptopCode as unknown as React.ComponentType<{ size?: number; className?: string }>;

  return (
    <Space>
      <NavigationButton
        text={t('Check My Github Profile')}
        onClick={() =>
          window.open('https://github.com/mahetab1357', '_blank')
        }
        icon={createElement(IconComp, { size: 22 })} // ✅ element via createElement
      />
      <div className="flex flex-row items-center gap-2 h-full">
        <ForwardBackwardsButton flip />
        <ForwardBackwardsButton flip={false} />
      </div>
    </Space>
  );
};

export default HistoryNavigation;
